export var SIZE_OPTIONS = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
export var CARRIER_TYPE_OPTIONS = {
  AIRLINE: "airline",
  BUS: "bus",
  TRAIN: "train"
};
export var BASE_URL = "//images.kiwi.com";